<template>
  <b-row>
    <b-col
      sm="12"
      md="6"
      lg="3"
      v-if="filterObject['numeroContrato'] !== undefined"
    >
      <b-form-group label="Nº Contrato" label-for="numeroContrato">
        <b-form-input
          id="numeroContrato"
          v-on:keyup.enter="$emit('change', {})"
          v-model="filterObject['numeroContrato']"
        >
        </b-form-input>
      </b-form-group>
    </b-col>
    <b-col
      sm="12"
      md="5"
      lg="3"
      v-if="filterObject['estado'] !== undefined"
    >
      <b-form-group label="Estado" label-for="estado">
        <b-form-select
          id="estado"
          :options="estados.map(estado => ({
            text: estado.descripcion,
            value: estado.estado,
          }))"
          @change="$emit('change', {})"
          v-model="filterObject['estado']"
        >
        </b-form-select>
      </b-form-group>
    </b-col>
    <b-col lg="1" class="icon" v-if="filterObject['estado'] !== undefined">
      <i class="hand bx bx-x font-size-24" @click="clear" />
    </b-col>
    <b-col sm="12" md="6" lg="3" v-if="filterObject['leaseType'] !== undefined">
      <lease-type
        v-model="filterObject['leaseType']"
        @change="$emit('chooseTable', {})"
      />
    </b-col>
    <b-col
      sm="12"
      md="5"
      lg="3"
      v-if="filterObject['inputNumber'] !== undefined"
    >
      <b-form-group :label="labelNumber" label-for="formrow-name-input">
        <b-form-input
          type="number"
          id="formrow-name-input"
          v-on:keyup.enter="$emit('change', {})"
          @keydown.space.prevent
          v-model="filterObject['inputNumber']"
        >
        </b-form-input>
      </b-form-group>
    </b-col>
    <b-col lg="1" class="icon" v-if="filterObject['inputNumber'] !== undefined">
      <i class="hand bx bx-x font-size-24" @click="clearInputNumber" />
    </b-col>
    <b-col hidden sm="12" md="6" lg="3">
      <select-rut
        v-model="filterObject['rutEmpresa']"
        @change="$emit('change', {})"
      />
    </b-col>
    <b-col sm="12" md="6" lg="3" v-if="filterObject['daterange'] !== undefined">
      <b-form-group label="Rango de fechas" label-for="formrow-name-input">
        <date-picker
          v-model="filterObject['daterange']"
          range
          append-to-body
          :lang="lang"
          confirm
          format="DD-MM-YYYY"
          @change="$emit('change', {})"
        ></date-picker>
      </b-form-group>
    </b-col>
    <b-col
        sm="12"
        md="6"
        lg="4"
        v-if="filterObject['patent'] !== undefined"
    >
      <select-patent
          v-model="filterObject['patent']"
          :patentView="patentView"
          @change="$emit('change', {})"
      />
      </b-col>
    <b-col
        sm="12"
        md="6"
        lg="4"
        v-if="filterObject['payState'] !== undefined"
    >
      <select-payState
          v-model="filterObject['payState']"
          @change="$emit('change', {})"
      />
    </b-col>

<!--Periods Filters-->

<!--    <b-col
      sm="12"
      md="6"
      lg="4"
      v-if="filterObject['period'] !== undefined && filterObject['patent'] && !filterObject['tag'] && filterObject['payState'] === undefined"
    >
      <select-periodo
        v-model="filterObject['period']"
        anioDesde="2000"
        anioHasta="2040"
        :patent="filterObject['patent']"
        @change="periodoChange"
      />
    </b-col>
    <b-col
        sm="12"
        md="6"
        lg="4"
        v-if="filterObject['period'] !== undefined && filterObject['leaseType'] === 'contratoLop'"
    >
      <select-periodo
          v-model="filterObject['period']"
          anioDesde="2000"
          anioHasta="2040"
          @change="periodoChange"
      />
    </b-col>
    <b-col
        sm="12"
        md="6"
        lg="4"
        v-if="filterObject['period'] !== undefined && filterObject['leaseType'] === 'boletaLop' || filterObject['leaseType'] === 'cotizacionLop'"
    >
      <select-periodo
          v-model="filterObject['period']"
          anioDesde="2000"
          anioHasta="2040"
          :patent="filterObject['patent']"
          @change="periodoChange"
      />
    </b-col>-->
    <b-col
        sm="12"
        md="6"
        lg="4"
        v-if="filterObject['period'] !== undefined && filterObject['tag'] && filterObject['patent'] && filterObject['payState'] === undefined"
    >
      <select-tag-period
          v-model="filterObject['period']"
          :patent="filterObject['patent']"
          @change="periodoChange"
      />
    </b-col>
    <!--<b-col
        sm="12"
        md="6"
        lg="4"
        v-if="filterObject['period'] !== undefined && !filterObject['patent'] && filterObject['tag']"
    >
      <select-periodo
          v-model="filterObject['period']"
          anioDesde="2000"
          anioHasta="2040"
          :patent="filterObject['patent']"
          @change="periodoChange"
      />
    </b-col>
    <b-col
        sm="12"
        md="6"
        lg="4"
        v-if="filterObject['payState'] !== undefined"
    >-->
    <b-col
        sm="12"
        md="6"
        lg="4"
        v-if="!filterObject['tag']"
    >
      <select-periodo
          v-model="filterObject['period']"
          anioDesde="2000"
          anioHasta="2040"
          :patent="filterObject['patent']"
          @change="periodoChange"
      />
    </b-col>
  </b-row>
</template>

<script>
import SelectRut from "./select-rut";
import DatePicker from "vue2-datepicker";
import DPConfig from "../dataPickerConf";
import LeaseType from "./LeaseType/lease-type";
import selectPeriodo from "../select-periodo";
import SelectPatents from "./SelectPatents"
import PayState from "./PayState"
import SelectTagPeriod from "./SelectTAGPeriod"
import axios from '@/axios'

export default {
  props: {
    filtros: Array,
    value: Object,
    labelNumber: {
      type: String,
      default: "Número",
    },
    patentView: String
  },
  data() {
    return {
      lang: {
        formatLocale: DPConfig.formatLocale,
      },
      rutEmpresa: "",
      daterange: [new Date("2000-01-01"), new Date()],
      patente: "",
      rut: false,
      date: false,
      period: false,
      contrato: false,
      estado: false,
      filterObject: this.value,
      fechaDesde: "",
      fechaHasta: "",
      estados: []
    };
  },
  created() {
    axios('/EstadosOT')
    .then(res => {
      res.data.map(obj => this.estados.push(obj))
    })
    .catch(error => console.error(error))
  },
  components: {
    DatePicker,
    "select-rut": SelectRut,
    "lease-type": LeaseType,
    "select-periodo": selectPeriodo,
    "select-patent": SelectPatents,
    "select-payState": PayState,
    "select-tag-period": SelectTagPeriod,
  },
  methods: {
    periodoChange(data) {
      this.fechaDesde = data.fechaDesde;
      this.fechaHasta = data.fechaHasta;
      this.filterObject["period"] = [this.fechaDesde, this.fechaHasta];
      this.$emit("change", {});
    },
    clear () {
      this.estado = '' 
      this.filterObject['estado'] = ''
      this.$emit("change", {});
    },
    clearInputNumber () {
      this.filterObject['inputNumber'] = ''
      this.$emit("change", {});
    }
  },
  beforeMount() {
    if (this.$store.getters["hideValue/detailId"]) {
      this.filterObject = this.$store.getters["hideValue/filter"];
      this.$store.dispatch("hideValue/updateId", null);
      this.$store.dispatch("hideValue/updateFilter", {});
      this.$emit("input", this.filterObject);
    }
  },
  watch: {
    rutEmpresa(newVal, oldVal) {
      // this check is mandatory to prevent endless cycle
      if (newVal !== oldVal) {
        this.$emit("select-rut", newVal);
        this.$emit("change", {});
      }
    },
    daterange(newVal, oldVal) {
      // this check is mandatory to prevent endless cycle
      if (newVal !== oldVal) {
        this.$emit("date-picker", newVal);
        this.$emit("change", {});
      }
    },
    period(newVal, oldVal) {
      // this check is mandatory to prevent endless cycle
      if (newVal !== oldVal) {
        this.$emit("fechaDesde", newVal);
        this.$emit("fechaHasta", newVal);
        this.$emit("change", {});
      }
    },
    payState(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("payState", newVal);
        this.$emit("change", {});
      }
    },
    estado(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$emit("estado", newVal);
        this.$emit("change", {});
      }
    },
    filterObject: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.icon {
  margin-left: -25px;
  margin-top: 35px;
}
</style>